import styled from "styled-components/macro";
import { focusVisibleInset } from "../../styles/a11y";

export const StyledBlankSlate = styled.div`
  width: 325px;
  height: 140px;
  position: relative;
  cursor: pointer;
  top: 280px;
  left: 320px;
  outline: 2px solid var(--grey-0);
  background: var(--menu-color);
  z-index: 2;

  .background-cover {
    background-image: url(/assets/brainstorm/something-else.svg);
    background-repeat: no-repeat;
    background-size: 75%;
    background-position: center 35%;
    width: 100%;
    height: 100%;
    -webkit-mask-image: radial-gradient(white, black);
  }

  .title {
    position: absolute;
    bottom: 15px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: "Inter";
    color: var(--grey-0);
  }

  &:hover {
    background-color: var(--menu-color-hover);
  }

  &:active {
    background-color: var(--menu-color-active);
  }

  ${focusVisibleInset}
  &:focus-visible {
    outline-offset: 0px !important;
    z-index: 3;
    outline: 3px solid var(--primary-cta);
  }
`;

export const StyledGridItem = styled.div`
  float: left;
  width: 160px;
  height: 140px;
  text-align: center;
  text-decoration: uppercase;
  outline: 2px solid var(--grey-0);
  background: var(--menu-color);
  z-index: 2;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: var(--menu-color-hover);
  }

  &:active {
    background-color: var(--menu-color-active);
  }

  &:focus-visible {
    outline-offset: 0px;
    z-index: 3;
    outline: 2px solid var(--primary-cta);
  }

  .background-cover {
    background-image: ${({ url }) => (url ? `url(/assets/brainstorm/${url}.svg)` : "none")};
    background-repeat: no-repeat;
    background-size: 40%;
    background-position: center 40%;
    width: 140px;
    height: 120px;
    padding: 10px;

    ${({ url }) => url === "world-building" && "background-size: 35%;"};
    ${({ url }) => url === "plot-points" && "background-size: 45%;"};
    ${({ url }) => url === "places" && "background-size: 35%;"};

    -webkit-mask-image: radial-gradient(white, black);
  }

  .title {
    position: absolute;
    bottom: 15px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    left: 0;
    font-family: "Inter";
    color: var(--grey-0);
  }
`;

export const StyledGrid = styled.div`
  a {
    position: relative;
    flex-basis: calc(25% - 2px);
    margin: 0px;
    border: 1px solid var(--grey-0);
    border-width: 0 0 1px 1px;
    box-sizing: border-box;

    &.top {
      border-top-width: 1px;
    }
    &.right,
    &.last {
      border-right-width: 1px;
    }

    &:hover {
      /* background: #eee; */
    }

    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    .content {
      color: var(--grey-0);
      font-size: 20px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex; /* added for centered text */
      justify-content: center; /* added for centered text */
      align-items: center; /* added for centered text */
      // &:active {
      //   background: white;
      //   color: black;
      // }

      div {
        text-align: center;
        flex: none;
        display: block;

        .icons {
          margin-top: 10px;
        }
      }
    }
  }
`;

export const StyledH1 = styled.h1`
  text-align: center;
`;

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100001;
  background: var(--menu-color);

  text-align: left;
  font-size: 18px;
  overflow: visible;

  h1 {
    font-family: "Inter";
    font-weight: bold;
    user-select: none;
    margin-bottom: 15px !important;
    color: var(--grey-0);
  }

  h3 {
    margin-top: 0;
    color: #444;
    font-family: "Inter";
  }

  .back-button {
    position: absolute !important;
  }
`;

export const StyledReviewContainer = styled.div`
  position: fixed;
  width: 840px;
  max-height: 745px;
  min-height: 560px;
  margin: auto;
  transition: all 0.3s ease-in-out;
  ${({ scale }) => scale && `transform: scale(${scale});`}
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const StyledBrainformContainer = styled.div`
  position: fixed;
  width: 660px;
  height: 600px;
  transition: all 0.3s ease-in-out;
  ${({ scale }) => scale && `transform: scale(${scale});`}
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  form {
    .bottom {
      position: fixed;
      bottom: 10px;
      right: 10px;
      font-size: 14px;
      color: #777;
    }

    input {
      font-size: 18px;
    }

    label {
      font-size: 16px;
      text-transform: uppercase;
      line-height: 1.5em;
      font-weight: 500;
      margin-bottom: 10px;
      display: block;
      a {
        color: #777;
        text-decoration: underline;
      }
    }
  }
`;

export const StyledStreamingListContainer = styled.div`
  position: fixed;
  width: 802px;
  transition: all 0.3s ease-in-out;
  ${({ scale }) => scale && `transform: scale(${scale});`}
  height: 705px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const StyledExamplesContainer = styled.div`
  position: fixed;
  width: 660px;
  transition: all 0.3s ease-in-out;
  ${({ scale }) => scale && `transform: scale(${scale});`}
  height: 600px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  h1 {
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px !important;
    font-size: 34px;
  }

  .examples {
    border: 2px solid var(--grey-0);
    border-radius: 20px;
    overflow: hidden;
    background: var(--grey-0);
    width: 640px;
    height: 420px;
  }
`;

export const StyledStartOverProTip = styled.div`
  top: 50px;
  left: 660px;

  > div {
    top: inherit;
    left: inherit;
  }
`;

export const StyledErrorMessage = styled.div`
  position: fixed;
  bottom: 30px;
  margin: auto;
  left: 0;
  right: 0;
  z-index: 999;
  width: 460px;
  display: inline-block;
  color: white;
  background: rgba(178, 178, 178);
  border-radius: 30px;
  padding: 15px;
  text-align: center;
`;
